import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import sendRequest from "../../../helpers/requestHelper";

const subscribe = {
    namespaced: true,
    state: {
        isFetching: false,
        stripeIsFetching1: false,
        stripeIsFetching3: false,
        stripeIsFetching6: false,
        stripeIsFetching12: false,
        isSubscribePaid: false,
        paymentLinkData: [],
        paymentStripeLink: null,
        subscriptionPlans: null,
        subscriptionPaypalPlan: null,
        isPaypalSubscribed: false,
    },
    mutations: {
        SUBSCRIBE_REQUEST(state, value) {
            state.isFetching = value;
        },

        STRIPE_SUBSCRIBE_REQUEST1(state, value) {
            state.stripeIsFetching1 = value;
        },
        STRIPE_SUBSCRIBE_REQUEST3(state, value) {
            state.stripeIsFetching3 = value;
        },
        STRIPE_SUBSCRIBE_REQUEST6(state, value) {
            state.stripeIsFetching6 = value;
        },
        STRIPE_SUBSCRIBE_REQUEST12(state, value) {
            state.stripeIsFetching12 = value;
        },

        SUBSCRIBE_SUCCESS(state, response) {
            state.paymentLinkData = response.data;
            eventBus.$emit('sendSubscribeLinkSuccess', response.data);
        },
        SUBSCRIBE_FAILURE(state, error) {
           console.log(error)
        },
        SUBSCRIBE_STRIPE_SUCCESS(state, response) {
            state.paymentStripeLink = response.data;
            eventBus.$emit('sendSubscribeStripeLinkSuccess', response.data);
        },
        SUBSCRIBE_STRIPE_FAILURE(state, error) {
           console.log(error)
        },
        SUBSCRIBTION_STRIPE_PLANS_SUCCESS(state, response) {
            state.subscriptionPlans = response.data;
        },
        SUBSCRIBTION_STRIPE_PLANS_FAILURE(state, error) {
           console.log(error)
        },
        SUBSCRIBTION_PAYPAL_PLAN_SUCCESS(state, response) {
            state.subscriptionPaypalPlan = response.data;
        },
        SUBSCRIBTION_PAYPAL_PLAN_FAILURE(state, error) {
           console.log(error)
        },
        PAYPAL_SUBSCRIBE_SUCCESS(state) {
            state.isPaypalSubscribed = true;
        },
        PAYPAL_SUBSCRIBE_FAILURE(state, error) {
           console.log(error)
        },
    },
    actions: {
        sendSubscribeLinkRequest({dispatch}) {
            dispatch("requestCheckout", true);
            var promise = sendRequest("post", config.baseURLApi+"/user-subscriptions/subscribe", {}, {}, true);

            promise.then(function($result) {
                if($result[0] === "success") {    
                    dispatch("successLogin", $result[1]);
                } else {
                    dispatch("failureLogin", $result[1]);
                }
            });
        },
        sendSubscribeStripeLink({dispatch}, payload) {
            dispatch("stripeRequestCheckout" + payload.interval, true);
            var promise = sendRequest("post", config.baseURLApi+"/user-subscriptions/stripe/payment-link/" + payload.interval, {}, {}, true);

            promise.then(function($result) {
                if($result[0] === "success") {
                    dispatch("successStripeLogin", $result[1]);
                } else {
                    dispatch("failureStripeLogin", $result[1]);
                }
            });
        },

        getSubscriptionPlans({dispatch}) {
            var promise = sendRequest("get", config.baseURLApi+"/user-subscriptions/stripe/prices", {}, {}, true);

            promise.then(function($result) {
                if($result[0] === "success") {
                    dispatch("succesGetSubscriptionPlans", $result[1]);
                } else {
                    dispatch("failureGetSubscriptionPlans", $result[1]);
                }
            });
        },

        getPaypalPlans({dispatch}) {
            var promise = sendRequest("get", config.baseURLApi+"/user-subscriptions/paypal/plans", {}, {}, true);

            promise.then(function($result) {
                if($result[0] === "success") {
                    dispatch("succesGetPaypalPlan", $result[1]);
                } else {
                    dispatch("failureGetPaypalPlan", $result[1]);
                }
            });
        },

        subscribePaypal({dispatch}, payload = {}) {
            var promise = sendRequest("post", config.baseURLApi+"/user-subscriptions/paypal/subscribe", {}, {}, true, payload);

            promise.then(function($result) {
                if($result[0] === "success") {
                    dispatch("succesPaypalSubscribe", $result[1]);
                } else {
                    dispatch("failurePaypalSubscribe", $result[1]);
                }
            });
        },


        // isPaymentSucceedRequest({})

        requestCheckout: function({ commit }, value) {
            commit("SUBSCRIBE_REQUEST", value);
        },

        stripeRequestCheckout1: function({ commit }, value) {
            commit("STRIPE_SUBSCRIBE_REQUEST1", value);
        },
        stripeRequestCheckout3: function({ commit }, value) {
            commit("STRIPE_SUBSCRIBE_REQUEST3", value);
        },
        stripeRequestCheckout6: function({ commit }, value) {
            commit("STRIPE_SUBSCRIBE_REQUEST6", value);
        },
        stripeRequestCheckout12: function({ commit }, value) {
            commit("STRIPE_SUBSCRIBE_REQUEST12", value);
        },

        successLogin: function({ commit }, response) {
            commit("SUBSCRIBE_SUCCESS", response);
        },
        failureLogin: function({ commit }, error) {
            commit("SUBSCRIBE_FAILURE", error);
        },
        successStripeLogin: function({ commit }, response) {
            commit("SUBSCRIBE_STRIPE_SUCCESS", response);
        },
        failureStripeLogin: function({ commit }, error) {
            commit("SUBSCRIBE_STRIPE_FAILURE", error);
        },
        updateVisibleModal(context, value)
        {
            context.commit('UPDATE_VISIBLE_MODAL', value)
        },
        succesGetSubscriptionPlans: function({ commit }, response) {
            commit("SUBSCRIBTION_STRIPE_PLANS_SUCCESS", response);
        },
        failureGetSubscriptionPlans: function({ commit }, error) {

            commit("SUBSCRIBTION_STRIPE_PLANS_FAILURE", error);
        },
        succesGetPaypalPlan: function({ commit }, response) {
            commit("SUBSCRIBTION_PAYPAL_PLAN_SUCCESS", response);
        },
        failureGetPaypalPlan: function({ commit }, error) {

            commit("SUBSCRIBTION_PAYPAL_PLAN_FAILURE", error);
        },
        succesPaypalSubscribe: function({ commit }, response) {
            commit("PAYPAL_SUBSCRIBE_SUCCESS", response);
        },
        failurePaypalSubscribe: function({ commit }, error) {

            commit("PAYPAL_SUBSCRIBE_FAILURE", error);
        },

    }
}

export default subscribe;